import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import { hasTouchEvents } from '../../util';

class Component extends BaseComponent {
    render({ user }) {
        return (
            <user-menu ref={this.trackClicks}>
                {user.logged_in ? this.renderLoggedIn() : this.renderLoggedOut()}
            </user-menu>
        );
    }

    renderLoggedIn() {
        return (
            <ul class='user-li'>
                {this.renderMyAccount()}
                <li class='ub-journal no-detail-link'>
                    <a
                      href='https://product.tarot.com/about-you/journal'
                      data-label='My Journal'
                    >
                        <h5>My Journal</h5>
                    </a>
                </li>
                <li class='my-kcs'>
                    <a href='/store/karma-coins' data-label='My Account - Karma Coins© Balance'>
                        <span />
                        <div class='account-details'>
                            <h5>Karma Coins<sup>®</sup></h5>
                            <p>{this.props.user.kcs.total.toLocaleString()} Balance</p>
                        </div>
                    </a>
                </li>
                <li class='ub-gear no-detail-link'>
                    <a href='/member/settings' data-label='My Account - Settings'>
                        <h5>Account Settings</h5>
                    </a>
                </li>
                <li class='ub-logout no-detail-link'>
                    <a href='#logout' data-label='Log Out'>
                        <h5>Log Out</h5>
                    </a>
                </li>
            </ul>
        );
    }

    renderMyAccount = () => {
        const avatar = this.props.user.avatar_url || 'https://gfx.tarot.com/images/site/tarot/ui/avatar-unknown.jpg';

        if (hasTouchEvents) {
            return [
                <li class='my-account'>
                    <div class='avatar-mask'>
                        <img src={avatar} alt='User profile picture' class='avatar' />
                    </div>
                    <div class='account-details'>
                        <h5>My Account</h5>
                        <p>{this.props.user.kcs.total.toLocaleString()} Karma Coins<sup>®</sup></p>
                    </div>
                </li>,
                <li class='my-account'>
                    <a href='/member/profile' data-label='My Account - Karma Coins®'>
                        <div class='avatar-mask'>
                            <img src='https://gfx.tarot.com/images/site/topbar/my-profile.svg' alt='My Profile' />
                        </div>
                        <div class='account-details'>
                            <h5>My Profile</h5>
                        </div>
                    </a>
                </li>,
            ];
        }

        return (
            <li class='my-account'>
                <a href='/member/profile' data-label='My Account - Karma Coins®'>
                    <div class='avatar-mask'>
                        <img src={avatar} alt='User profile picture' class='avatar' />
                    </div>
                    <div class='account-details'>
                        <h5>My Account</h5>
                        <p>{this.props.user.kcs.total.toLocaleString()} Karma Coins<sup>®</sup></p>
                    </div>
                </a>
            </li>
        );
    }

    renderLoggedOut() {
        return (
            <ul class='user-lo'>
                <li>
                    <a href='#login' data-label='Log In' onClick={this.login}>Log In</a>
                </li>
                <li>
                    <a href='#signup' class='button' data-label='Sign Up' onClick={this.signUp}>Sign Up!</a>
                </li>
            </ul>
        );
    }

    login = () => {
        this.props.routeTo('login');
    }

    signUp() {
        const signup_gateway = document.querySelector('input[name="signup_gateway"]');

        if (signup_gateway) {
            signup_gateway.value = '#signup';
        }

        return true;
    }

    trackClicks = (node) => {
        if (node) {
            const anchors = node.querySelectorAll('a');

            if (anchors.length) {
                Array.prototype.forEach.call(anchors, a => {
                    a.addEventListener('click', this.trackClick);
                });
            }
        }
    };


    trackClick = (e) => {
        const category = 'UserBar';
        const action = this.props.user.logged_in ? 'LI Click' : 'LO CLick';
        const label = e.currentTarget.dataset.label;

        this.props.trackEvent([category, action, label]);
        this.props.trackPromo([category, label]);

        return true;
    };
}

const mapStateToProps = (state) => ({
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: data => dispatch({ type: 'ga:event', payload: data }),
    trackPromo: payload => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
    routeTo: route => dispatch({ type: 'route:to', payload: route }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/user/menu.js